import React from 'react';

import { IconProps } from './types';

const MinusIcon: React.FC<IconProps> = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_518_26595" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_518_26595)">
        <path d="M5 13V11H19V13H5Z" fill="#585757" />
      </g>
    </svg>
  );
};

export default MinusIcon;
